import UserMenu from './user';
import SideMenu from './side';
import FooterMenu from './footer';

export { UserMenu, SideMenu, FooterMenu };



// WEBPACK FOOTER //
// ./src/components/menus/index.js